import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252,replace 0,1,2) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'AMPLE',
    lpAddresses: {
      97: '0x19857937848c02afbde8b526610f0f2f89e9960d',
      56: '0x19857937848c02afbde8b526610f0f2f89e9960d',
    },
    token: tokens.syrup,
    quoteToken: tokens.wbnb,
  },
  
  
 
  {
    pid: 1,
    lpSymbol: 'AMPLE-BNB LP',
    lpAddresses: {
      97: '0x471a6df20130f0559e931386e47d65fff31dd7aa',
      56: '0x471a6df20130f0559e931386e47d65fff31dd7aa',
    },
    token: tokens.ample,
    quoteToken: tokens.wbnb,
  },
  
  {
    pid: 2,
    lpSymbol: 'BUSD-BNB LP',
    lpAddresses: {
      97: '0x529d8d8b1050191aca8e45792c811ecc1b3e8461',
      56: '0x529d8D8B1050191Aca8e45792C811EcC1B3e8461',
    },
    token: tokens.busd,
    quoteToken: tokens.wbnb,
    },
	
	{
	pid: 58,
	lpSymbol: 'BTCB-ETH LP',
	lpAddresses: {
	97: '',
	56: '0x31a5f79c79186314365a94e557f5712c5913f45e',
	},
	token: tokens.btcb,
	quoteToken: tokens.eth,
	},
	
	{
	pid: 12,
	lpSymbol: 'USDC-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x861f685da59c51909e5b54d81404b073d35adf9b',
	},
	token: tokens.usdc,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 9,
	lpSymbol: 'USDT-BNB LP',
	lpAddresses: {
	97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
	56: '0xe889c835030a21b12656d7799de8326c1560198e',
	},
	token: tokens.usdt,
	quoteToken: tokens.wbnb,
	},

	{
	pid: 51,
	lpSymbol: 'ETH-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x6343ffa0b8716fdf325d85a9b149c7f6e4206223',
	},
	token: tokens.eth,
	quoteToken: tokens.wbnb,
	},

//   ************************* *****************  big projects  ************************************************************ 

	
	
	{
	pid: 54,
	lpSymbol: 'SOL-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xb17fbdc93cabebd07e3ed187ad37ef8c795524ee',
	},
	token: tokens.sol,
	quoteToken: tokens.wbnb,
	}, 
		
	{
	pid: 57,
	lpSymbol: 'ADA-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x6dfc743c6dbd77b8a4345ea9dd6295fcfc2811b7',
	},
	token: tokens.ada,
	quoteToken: tokens.wbnb,
	}, 
  
  
	{
	pid: 52,
	lpSymbol: 'LINK-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x3b4a4ad013040f61d5f5d107e9f60429f67ca65e',
	},
	token: tokens.link,
	quoteToken: tokens.wbnb,
	}, 
	
	{
	pid: 55,
	lpSymbol: 'DOT-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x69054b8160a67815238b6ff542709b87acdfc654',
	},
	token: tokens.dot,
	quoteToken: tokens.wbnb,
	}, 
	
	{
	pid: 56,
	lpSymbol: 'DOGE-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xdec13fe0641ae31d4f8b3e5484063ed9615c5457',
	},
	token: tokens.doge,
	quoteToken: tokens.wbnb,
	}, 
	
	
	{
	pid: 3,
	lpSymbol: 'AMPLE-BUSD * Pancake Lp V2',
	lpAddresses: {
	97: '',
	56: '0x8dabad1f1c7b51e58e0711029de4f66a6d17bd75',
	},
	token: tokens.ample,
	quoteToken: tokens.busd,
	},
	
	{
	pid: 53,
	lpSymbol: 'BTCB-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x7682c715304aa1306e79a137d017050db6937987',
	},
	token: tokens.btcb,
	quoteToken: tokens.wbnb,
	},
	
	{
	pid: 11,
	lpSymbol: 'BTCB-USDT LP',
	lpAddresses: {
	97: '',
	56: '0xa79797bdbc375f798313304893917e97a7216f3b',
	},
	token: tokens.btcb,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 10,
	lpSymbol: 'ETH-USDT LP',
	lpAddresses: {
	97: '',
	56: '0xb4c5fda168e83ab37526104bb3efe53dbbb72726',
	},
	token: tokens.eth,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 39,
	lpSymbol: 'TUSD-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x00a3ac683d44cecb92ffc793394fbf31c32897b4',
	},
	token: tokens.tusd,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 15,
	lpSymbol: 'DOGE-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x632598eeed843ceccab1dfbf369f742db39dd1b0',
	},
	token: tokens.doge,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 8,
	lpSymbol: 'BUSD-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x967f8f1cf7cb261e9c45979261813a33da043d9d',
	},
	token: tokens.busd,
	quoteToken: tokens.usdt,
	},
	
	{
	pid: 13,
	lpSymbol: 'LINK-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x3fd00f6360069520d9b837e0e463305ff292147b',
	},
	token: tokens.link,
	quoteToken: tokens.usdt,
	},

	{
	pid: 14,
	lpSymbol: 'ADA-USDT LP',
	lpAddresses: {
	97: '',
	56: '0x74e171d4abae1fbd6fed15fecf6eb2447510b605',
	},
	token: tokens.ada,
	quoteToken: tokens.usdt,
	},
	
	
	

//   ************************* ***************** Client Project  ************************************************************
	{
	pid: 7,
	lpSymbol: 'wALV-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x01264f5e9bae17702bc385cabc073155c6352b96',
	},
	token: tokens.walv,
	quoteToken: tokens.wbnb,
	}, 
	
	{
	pid: 50,
	lpSymbol: 'OK-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xae0a7ace5af2b2aef07913fef52b644bab6b0323',
	},
	token: tokens.ok,
	quoteToken: tokens.wbnb,
	}, 
	
	{
	pid: 46,
	lpSymbol: 'FLASH-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x30fa1fcb55bd68195980f31af32a732464fff83c',
	},
	token: tokens.flash,
	quoteToken: tokens.wbnb,
	}, 

	{
	pid: 48,
	lpSymbol: 'AMPLE-FLASH LP',
	lpAddresses: {
	97: '',
	56: '0x919c035fef8141f995f4a151488c157499fa8662',
	},
	token: tokens.ample,
	quoteToken: tokens.flash,
	}, 
	
	
	
//   *********************************** finished project pid  ***********************************	
	{
	pid: 44,
	lpSymbol: 'BLES-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x4a28407692b926a104b6e4b04052e27a1e221459',
	},
	token: tokens.bles,
	quoteToken: tokens.wbnb,
	},
	
	{
	pid: 21,
	lpSymbol: 'FRTC-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xa6fa80286d871a11aca06183e51002c4c8f27874',
	},
	token: tokens.frtc,
	quoteToken: tokens.wbnb,
	},
	
	
	{
	pid: 18,
	lpSymbol: 'SWEEP-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xf34d167cca169e7b3247b0d0b49111534b725e36',
	},
	token: tokens.sweep,
	quoteToken: tokens.wbnb,
	},
	
	{
	pid: 6,
	lpSymbol: 'CUBY-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x4b7e5fc3178d0728a9e3782086cebaa8839ba340',
	},
	token: tokens.cuby,
	quoteToken: tokens.wbnb,
	},
	
	{
	pid: 31,
	lpSymbol: 'NSDX-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x26607FEa66D811d2FA2388CA8A542b43Fd0ed2A1',
	},
	token: tokens.nsdx,
	quoteToken: tokens.wbnb,
	},
	
	{
	pid: 20,
	lpSymbol: 'POSS-BNB LP',
	lpAddresses: {
	97: '',
	56: '0xf76e923960b196d89a2f414dce89861cec09dff9',
	},
	token: tokens.poss,
	quoteToken: tokens.wbnb,
	},
	
    {
	pid: 32,
	lpSymbol: 'CROOGE-BNB LP',
	lpAddresses: {
	97: '',
	56: '0x109c55b96f8546200f0aa553241ac02a2c86b1e4',
	},
	token: tokens.crooge,
	quoteToken: tokens.wbnb,
	},
	

]

export default farms
